import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/de/community')({
  component: Outlet,
})
